import MarkdownIt from 'markdown-it';

const ALLOWED_TAGS = ['p', 'h1', 'h2', 'h3', 'h4', 'strong', 'em', 'ul', 'ol', 'li', 'hr', 'blockquote', 'code', 'pre', 'u'];

const allowedSet = new Set(
  ALLOWED_TAGS.flatMap(t => [`<${t}>`, `</${t}>`])
);

function allowlistHtmlPlugin(md) {
  md.core.ruler.push('allowlist_html', (state) => {
    for (const token of state.tokens) {
      if (!token.children) continue;
      for (const child of token.children) {
        if (child.type === 'html_inline' && !allowedSet.has(child.content.toLowerCase())) {
          child.type = 'text';
        }
      }
    }
  });
}

const md = new MarkdownIt({ html: true }).use(allowlistHtmlPlugin);

export function markdownToHTML(text) {
  return md.render(text || '');
}
